module.exports = __webpack_public_path__ + "static/media/FLIP 3.907ea586.jpg";